import { Injectable } from "@angular/core";
import { ValueTypedEndPoint } from "@app/services/valueType/valueType-endpoint.service";
import { Observable } from "rxjs/Observable";
import { Observer } from 'rxjs/Observer';
import { ValueType } from "@app/common/valuetype";
import { Subscription } from "rxjs/Subscription";
import { LocationType, Country } from "@app/common/app-enum";
import { ProfileDetialsModel } from "@app/models/ProfileDetailsModel";


@Injectable()
export class ValueTypeService {

    constructor(private valuedTypedEndpoint: ValueTypedEndPoint) { }
   
    getValueType(parameter: number){
        return this.valuedTypedEndpoint.getValueType(parameter);
        
    }
    getTerminalList(parameter){
        return this.valuedTypedEndpoint.getTerminalList(parameter);
      }
  
      getMerchantByEntityId(){
        return this.valuedTypedEndpoint.getMerchantByEntityId();
      }
      getOutlets(){
        return this.valuedTypedEndpoint.getOutlets();
      }
}


// WEBPACK FOOTER //
// ./src/app/services/valueType/valuetype.service.ts